import { n as removeTrapFocus, r as trapFocus } from "@theme/theme";
import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/header-mobile.js
var HeaderMobile = class extends HTMLElement {
	connectedCallback() {
		this.details = this.querySelector("details");
		this.summary = this.querySelector("summary");
		this.panel = document.getElementById("menu-drawer");
		gsapWithCSS.set(this.panel, { xPercent: -100 });
		this.summary.addEventListener("click", (e) => {
			e.preventDefault();
			this.isOpen() ? this.close() : this.open();
		});
		this.details.addEventListener("keyup", (e) => {
			if (e.code.toUpperCase() === "ESCAPE") this.close();
		});
		this.onBodyClickEvent = this.onBodyClick.bind(this);
	}
	isOpen() {
		return this.details.hasAttribute("open");
	}
	open() {
		const headerSection = document.getElementById("shopify-section-header");
		const announcementBar = document.querySelector(".announcement-bar");
		const headerBottom = headerSection?.getBoundingClientRect().bottom ?? 0;
		const announcementBottom = announcementBar?.getBoundingClientRect().bottom ?? 0;
		this.panel.style.top = `${Math.max(headerBottom, announcementBottom, 0)}px`;
		this.details.setAttribute("open", true);
		this.details.classList.add("menu-opening");
		this.summary.setAttribute("aria-expanded", "true");
		document.body.classList.add("overflow-hidden", "lg:overflow-auto");
		document.body.addEventListener("click", this.onBodyClickEvent);
		trapFocus(this.panel);
		gsapWithCSS.to(this.panel, {
			xPercent: 0,
			duration: .4,
			ease: "cubic-bezier(0.4, 0, 0.2, 1)"
		});
	}
	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summary : null);
		document.body.removeEventListener("click", this.onBodyClickEvent);
		document.body.classList.remove("overflow-hidden", "lg:overflow-auto");
		this.details.classList.remove("menu-opening");
		this.summary.setAttribute("aria-expanded", "false");
		gsapWithCSS.to(this.panel, {
			xPercent: -100,
			duration: .4,
			ease: "cubic-bezier(0.4, 0, 0.2, 1)",
			onComplete: () => this.details.removeAttribute("open")
		});
	}
	onBodyClick(event) {
		if (!this.contains(event.target)) this.close(false);
	}
};
window.customElements.define("header-mobile", HeaderMobile);
//#endregion
